import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Spin } from 'antd';

import { createMarkup } from '../../utils/createMarkup';

const PolicyDetails = memo(({ isFetchingList, policyDetails, isLoading, title }) => {
  return (
    <>
      <Spin
        spinning={isLoading || isFetchingList}
        wrapperClassName={(isLoading || isFetchingList) && 'ant-spin--fullscreen policy'}
        className={(isLoading || isFetchingList) && 'ant-spin--fullscreen policy'}
      >
        <div className='cookie'>
          <h4 className='mb-4'>{policyDetails?.title}</h4>
          <div dangerouslySetInnerHTML={createMarkup(policyDetails?.content)}></div>
        </div>
        {!isLoading && !policyDetails?.content && (
          <div className='cookie'>
            <h4 className='mb-4'>{title}</h4>
            <span className='fz-16 fw-600'>No data available</span>
          </div>
        )}
      </Spin>
    </>
  );
});

PolicyDetails.propTypes = {
  policyDetails: PropTypes.object,
  isLoading: PropTypes.bool,
  isFetchingList: PropTypes.bool,
  title: PropTypes.string,
};

PolicyDetails.defaultProps = {
  policyDetails: null,
  isLoading: false,
  isFetchingList: false,
};

export default PolicyDetails;